import { render, staticRenderFns } from "./CardBoat.vue?vue&type=template&id=73f38814&"
import script from "./CardBoat.vue?vue&type=script&lang=js&"
export * from "./CardBoat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports